// O seletor de tipos de questão é renderizado pelo ERB deste formulário, então
// o CSS e o tracking dele precisam acompanhar o formulário — e não só o entry
// da página de questões, senão as demais telas o renderizam sem estilo.
import '../question_type_tabs';
import './index.scss';
import 'components/modals/filter_generate_notebook_modal';
import 'components/modals/practice_test_cannot_create_modal';
import 'components/modals/practice_test_redirect_board_modal';
import 'components/select';
import 'utils/autofill_by_query_string';
import 'utils/current_user';
import 'utils/filter_form';
import 'utils/form_data_summary';
import DisciplinesSubjectsSelect from 'utils/disciplines_subjects_select';
import FilterFormTracker from 'utils/filter_form/options/track';
import ModalManager from 'utils/modal_manager';

(function ($) {
  const $filterForm = $('#js-questions-filter-form');
  const $disciplineSelect = $('#discipline_ids', $filterForm);
  const $subjectSelect = $('#subject_ids', $filterForm);
  const $filterButton = $('.js-filter-button', $filterForm);
  const $relevanceSelect = $('#relevance', $filterForm);
  const $filterFormToggle = $('#filter-form-desktop-toggle');
  const isUserSignedIn = window.currentUser;

  const dataForm = $filterForm.data();

  if (
    isUserSignedIn &&
    localStorage &&
    localStorage.getItem('showQuestionFilter')
  ) {
    const isActive = localStorage.getItem('showQuestionFilter') === 'true';
    $filterFormToggle.prop('checked', !isActive).trigger('change');
  }

  DisciplinesSubjectsSelect.init($disciplineSelect, $subjectSelect);
  const searchQuery = gon.search_params || null;

  // Checkbox marcado + hidden false no mesmo name geram URL duplicada
  // (exclude_*=false&exclude_*=true). Desabilita o hidden no checked para
  // manter opt-out (false) sem sujar a query quando o default (true) vale.
  const syncExclusionOptOutHiddens = () => {
    $filterForm.find('[data-exclusion-toggle]').each((_, checkbox) => {
      const $checkbox = $(checkbox);
      const $hidden = $filterForm.find(
        `[data-exclusion-opt-out][name="${$checkbox.attr('name')}"]`
      );

      if (!$hidden.length) {
        return;
      }

      $hidden.prop('disabled', $checkbox.is(':checked'));
    });
  };

  $filterForm
    .filterForm({ track: true, trackDataLayer: true })
    .formDataSummary('.js-summary')
    .autoFillByQueryString(searchQuery)
    .lazyReady();

  syncExclusionOptOutHiddens();
  $filterForm.on(
    'change',
    '[data-exclusion-toggle]',
    syncExclusionOptOutHiddens
  );
  $filterForm.on('submit', syncExclusionOptOutHiddens);

  $filterFormToggle.on('change', e => {
    if (!localStorage) {
      return;
    }

    localStorage.setItem(
      'showQuestionFilter',
      (!e.currentTarget.checked).toString()
    );
  });

  $filterButton.on('click', () => {
    if (dataForm.enableTrack) {
      UserTracker.emit('event', {
        eventName: 'questions searched',
        data: {
          ...new FilterFormTracker($filterForm).parse(),
          'search engine': gon.suricate_search_enabled
            ? 'suricate'
            : 'elasticsearch'
        }
      });
    }
  });

  $relevanceSelect.on('click', () => {
    ModalManager.open('#js-questions-relevance-modal');

    UserTracker.emit('event', {
      eventName: 'fake door clicked',
      data: {
        'feature name': 'Filtro Relevância'
      }
    });
  });
})(jQuery);
